import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWaste: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="waste, trash-can"><path d="M18.5 17L19.25 5.83333L17.1786 2.75H6.82143L4.75 5.83333L5.78571 21.25H14.5893" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 6H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19 19C19 20.3807 17.8807 21.5 16.5 21.5C15.1193 21.5 14 20.3807 14 19C14 17.6193 15.1193 16.5 16.5 16.5C17.8807 16.5 19 17.6193 19 19Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconWaste;
